import { Fetch } from '../../shared/types';

type TransferSession = {
  account_id: number;
  email: string;
  first_name: string;
  id: number;
  last_name: string;
  photo_url: string;
  zapier_customuser_id: number;
};

type RequestData = {
  cookie?: string;
};

export const getSession = (
  fetch: Fetch,
  /** Cookies need to be manually set when request is made server-side */
  { cookie }: RequestData
): Promise<TransferSession> =>
  fetch('v1/users/me/', cookie ? { headers: { Cookie: cookie } } : {});

export default getSession;
